export default "__VITE_ASSET__9c3e756c__"